<template>
  <div style="width: 900px;" id="printArea">
    <h3 style="display: flex;justify-content: center;">{{tableData.title || ''}}</h3>
    <div style="width: 100%;">
      <table border="1" cellpadding="0" cellspacing="0" style="width:100%;">
        <tr>
          <td style="width: 11%;">机构编码</td>
          <td style="width: 12%;">{{tableData.fixMedinsCode || ''}}</td>
          <td colspan="2">医保结算级别</td>
          <td>{{tableData.settlementLevel || ''}}</td>
          <td style="width: 10%;">机构名称</td>
          <td colspan="4">{{tableData.fixMedinsName || ''}}</td>
        </tr>
        <tr>
          <td>姓名</td>
          <td>{{tableData.patientName || ''}}</td>
          <td>性别</td>
          <td style="width:4%">{{tableData.gend || ''}}</td>
          <td>出生日期</td>
          <td>{{tableData.brdy || ''}}</td>
          <td>人员类别</td>
          <td>{{tableData.psnTypeName || ''}}</td>
          <td>公务员标志</td>
          <td style="width: 6%">{{tableData.cvlservFlag || ''}}</td>
        </tr>
        <tr>
          <td>单位名称</td>
          <td colspan="4">{{tableData.empName || ''}}</td>
          <td>联系电话</td>
          <td>{{tableData.mobile || ''}}</td>
          <td>人员身份类别</td>
          <td colspan="2">{{tableData.personTypeName || ''}}</td>
        </tr>
        <tr>
          <td>结算ID</td>
          <td>{{tableData.setlId || ''}}</td>
          <td>住院号</td>
          <td colspan="2">{{tableData.hospitalNo || ''}}</td>
          <td>医疗类别</td>
          <td>{{tableData.medTypeName || ''}}</td>
          <td>住院天数</td>
          <td colspan="2">{{tableData.hospitalDays || ''}}</td>
        </tr>
        <tr>
          <td>身份证号</td>
          <td colspan="4">{{tableData.idCard || ''}}</td>
          <td>险种</td>
          <td>{{tableData.insutypeName || ''}}</td>
          <td>参保医保区划</td>
          <td colspan="2">{{tableData.insuOptinsName || ''}}</td>
        </tr>
        <tr>
          <td>科别</td>
          <td>{{tableData.dept || ''}}</td>
          <td>床号</td>
          <td colspan="2">{{tableData.bedNo || ''}}</td>
          <td>入院日期</td>
          <td>{{tableData.inHospDate || ''}}</td>
          <td>出院日期</td>
          <td colspan="2">{{tableData.outHospDate || ''}}</td>
        </tr>
        <tr>
          <td>入院主要诊断</td>
          <td colspan="2">{{tableData.inHospDiag || ''}}</td>
          <td colspan="2">出院主要诊断</td>
          <td colspan="2">{{tableData.outHospDiag || ''}}</td>
          <td>结算时间</td>
          <td colspan="2">{{tableData.setlTime || ''}}</td>
        </tr>
        <tr>
          <td>项目名称</td>
          <td>金额</td>
          <td colspan="3">#符合政策范围</td>
          <td colspan="2">#先行自付</td>
          <td>#全自费</td>
          <td colspan="2">#超限价</td>
        </tr>
        <tr v-for="item in tableData.chrgitmList">
          <td>{{item.chrgitmName}}</td>
          <td>{{item.detItemFeeSumamt}}</td>
          <td colspan="3">{{item.inscpScpAmt}}</td>
          <td colspan="2">{{item.preselfpayAmt}}</td>
          <td>{{item.fulamtOwnpayAmt}}</td>
          <td colspan="2">{{item.overlmtAmt}}</td>
        </tr>
        <tr>
          <td colspan="2">起付线</td>
          <td colspan="3">{{tableData.actPayDedc}}</td>
          <td colspan="2">基本统筹基金支付</td>
          <td colspan="3">{{tableData.hifpPay}}</td>
        </tr>
        <tr>
          <td colspan="2">大病基金支付</td>
          <td colspan="3">{{tableData.hifmiPay}}</td>
          <td colspan="2">医疗救助金支付</td>
          <td colspan="3">{{tableData.mafPay}}</td>
        </tr>
        <tr>
          <td colspan="2">个人账户支付</td>
          <td colspan="3">{{tableData.acctPay}}</td>
          <td colspan="2">公务员补助支付</td>
          <td colspan="3">{{tableData.cvlservPay}}</td>
        </tr>
        <tr>
          <td colspan="2">其他基金支付</td>
          <td colspan="3">{{tableData.othPay}}</td>
          <td colspan="2">个人现金支付</td>
          <td colspan="3">{{tableData.cashPayamt}}</td>
        </tr>
        <tr>
          <td colspan="2">医院垫付金额</td>
          <td colspan="3">{{tableData.hospPay}}</td>
          <td colspan="2"></td>
          <td colspan="3"></td>
        </tr>
        <tr>
          <td colspan="10">
            {{`本次就医：总费用${tableData.medTreatement}元，基金支付总额${tableData.hifpPay}元，个人账户支付${tableData.acctPay}元，个人现金支付${tableData.cashPayamt}元`}}
          </td>
        </tr>
        <tr>
          <td colspan="10">
            <div style="display: flex;justify-content: space-around;">
              <div>备注:其他基金支付包含军转、财政、慈善、商保等支付来源。</div>
              <div>{{`打印时间:${tableData.printTime || ''}`}}</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "haErBinPrintModel",
  data() {
    return {
      tableData: {},
    };
  },
  methods: {
    handlePrint() {
      let dom = document.querySelector('#printArea');
      dom.style.display = 'block';
      this.$print(dom);
    },
  },
};
</script>
<style lang="less" scoped>
.outCon {
  width: 800px;
}
</style>
